import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import tableImage from "../../../../public/img/table.png";
import sunImage from "../../../../public/img/sun.png";
import moonImage from "../../../../public/img/moon.png";
import { EGameStatus, EPlayerGameStateKeysPrivate, EPlayerGameStateKeysPublic, ERoleTypes, getPlayerGameStateString, } from "../../../types";
import PlayerCard from "../../atoms/PlayerCard/PlayerCard";
import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "../../../hooks";
import { selectMatchState, selectShowRoles } from "../../../store/match";
const TableWrapper = styled.div `
  position: fixed;
  inset: 0;
  right: 270px;

  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
const PlayersWrapper = styled.div `
  position: absolute;
  inset: 0;
  z-index: 30;

  display: grid;
  grid-template-columns: repeat(4, 100px);
  gap: 0 16px;
  align-content: center;
  justify-content: center;
  margin: auto;
  gap: 16px;
`;
const ImageWrapper = styled.div `
  position: absolute;
  inset: 0;

  width: 1928px;
  height: 561px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 48px;
  transform: translateY(68px);

  background-image: url(${tableImage});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;
const TimeImage = styled.img `
  position: absolute;
  top: ${(props) => (props.day ? "0" : "41px")};
  left: ${(props) => (props.day ? "67px" : "91px")};
  display: block;

  width: ${(props) => (props.day ? "508px" : "400px")};
  height: ${(props) => (props.day ? "425px" : "351px")};
`;
const getTableLength = (playersCount) => {
    const minWidth = 770;
    const maxWidth = 2000;
    const spaceForPlayer = 170;
    const actualWidth = minWidth + Math.ceil((playersCount - 10) / 2) * spaceForPlayer;
    if (playersCount < 10) {
        return minWidth;
    }
    return actualWidth > maxWidth ? maxWidth : actualWidth;
};
const getTableLeftPosition = (playersCount, width) => {
    if (getTableLength(playersCount) + 270 > width) {
        return 0;
    }
    return width - getTableLength(playersCount) - 270;
};
const Wrapper = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${(props) => getTableLeftPosition(props.playersCount, props.width)}px;

  width: ${(props) => getTableLength(props.playersCount)}px;
  overflow: hidden;
`;
export const TableComponent = ({ day, players, onPlayerClickInner, selectedPlayer, selectedPlayers, addOnComponent, onFoulsClick, onChangeRole, voteItems, }) => {
    TimeImage.defaultProps = {
        src: day ? sunImage : moonImage,
    };
    const matchState = useAppSelector(selectMatchState);
    const showRoles = useAppSelector(selectShowRoles);
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    const gameStatus = useMemo(() => matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus, [matchState]);
    const candidates = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).candidates || [], [matchState]);
    const votes = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).votes || [], [matchState]);
    const isSuggested = (playerId) => candidates.find((c) => c.id === playerId);
    const isCurrentPlayer = (playerId) => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer) === playerId; };
    const roundStarter = (playerId) => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.roundStarter) === playerId; };
    const votesCount = (playerId) => {
        const result = votes.find((c) => c.playerId === playerId);
        console.log(result);
        return (result === null || result === void 0 ? void 0 : result.votes) || (result === null || result === void 0 ? void 0 : result.count) || 0;
    };
    const getPlayer = (playerId) => matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
    const getPlayerPositions = (players) => {
        const totalPositions = 25;
        const numPlayers = players.length;
        const positions = [];
        // Определяем размер первой и второй группы
        const firstGroupSize = Math.floor(numPlayers / 2) + 1;
        const secondGroupSize = numPlayers - firstGroupSize;
        // Назначаем позиции для первой группы (в обратном порядке)
        for (let i = firstGroupSize - 1; i >= 0; i--) {
            positions.push(i);
        }
        // Назначаем позиции для второй группы (с конца стола, в обратном порядке)
        const startPositionSecondGroup = totalPositions - secondGroupSize;
        for (let i = secondGroupSize - 1; i >= 0; i--) {
            positions.push(startPositionSecondGroup + i);
        }
        return positions;
    };
    // Get positions for current players
    const playerPositions = getPlayerPositions(players);
    const votingProcess = gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
        gameStatus === EGameStatus.PLAYER_VOTING ||
        gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE;
    return (_jsx(TableWrapper, { children: _jsx(Wrapper, Object.assign({ playersCount: players.length, width: width }, { children: _jsxs(ImageWrapper, { children: [_jsx(PlayersWrapper, { children: players.map((p, i) => {
                            var _a, _b;
                            const selected = (gameStatus === EGameStatus.MAFIA_MEETS &&
                                p.team === "MAFIA") ||
                                (gameStatus === EGameStatus.ROLE_PERFORM_NIGHT_ACTION &&
                                    p.role === (matchState === null || matchState === void 0 ? void 0 : matchState.state.currentRole)) ||
                                p.team === (matchState === null || matchState === void 0 ? void 0 : matchState.state.currentRole) ||
                                (gameStatus !== EGameStatus.MAFIA_MEETS &&
                                    gameStatus !== EGameStatus.ROLE_PERFORM_NIGHT_ACTION);
                            const suggested = 
                            // eslint-disable-next-line no-nested-ternary
                            gameStatus === EGameStatus.PLAYER_VOTING ||
                                gameStatus === EGameStatus.PLAYER_VOTE_STATE
                                ? selected && !isCurrentPlayer(p.id)
                                : gameStatus === EGameStatus.ROLE_PERFORM_NIGHT_ACTION
                                    ? selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => player.id === p.id)
                                    : !!isSuggested(p.id) &&
                                        (selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => player.id === p.id));
                            const disable = (roundStarter(p.id) && !selected) ||
                                // eslint-disable-next-line no-nested-ternary
                                (gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE ||
                                    gameStatus === EGameStatus.SELECT_DIRECTION_OF_INTRODUCE ||
                                    gameStatus === EGameStatus.PLAYER_VOTING ||
                                    gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                                    gameStatus === EGameStatus.PLAYER_INTRODUCING ||
                                    gameStatus === EGameStatus.INTRODUCE_YOURSELF_STATE ||
                                    gameStatus === EGameStatus.ROLE_PERFORM_NIGHT_ACTION
                                    ? !suggested && !selected
                                    : candidates.length
                                        ? !suggested
                                        : false);
                            const playerState = {
                                selected,
                                suggested,
                                disable: gameStatus === EGameStatus.GAME_ROLE_SETTING_NIGHT
                                    ? p.role !== ERoleTypes.CIVILIAN &&
                                        !(selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => player.id === p.id))
                                    : disable,
                                gameState: selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.state,
                                votesCount: votesCount(p.id),
                            };
                            const stateStrings = getPlayerGameStateString(p.state || null);
                            const publicStatus = Object.values(EPlayerGameStateKeysPublic).map((key) => (stateStrings[key] ? stateStrings[key] : null));
                            if (playerState.votesCount > 0) {
                                publicStatus[3] = `Голосов ${playerState.votesCount}`;
                            }
                            const privateStatus = Object.values(EPlayerGameStateKeysPrivate).map((key) => (stateStrings[key] ? stateStrings[key] : null));
                            const currentStatus = showRoles
                                ? [...publicStatus, ...privateStatus]
                                : publicStatus;
                            const voteTarget = p === selectedPlayer && votingProcess;
                            const isCurrent = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer) === p.id;
                            const haveVotes = votes.some((target) => target.playerId === p.id);
                            const position = playerPositions[i]; // This is the position index for the player
                            return (_jsx(PlayerCard, { player: p, voteTarget: voteTarget, selected: selected, selectedPlayer: selectedPlayer, showRoles: showRoles, currentStatus: currentStatus, position: position, onClick: onPlayerClickInner, isCurrent: isCurrent, roundStarter: ((_b = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _b === void 0 ? void 0 : _b.roundStarter) === p.id, haveVotes: haveVotes, votesCount: votesCount }, p.id)
                            // <TableRow
                            //   key={p.id}
                            //   id={p.id}
                            //   selected={selected}
                            //   onClick={() => onPlayerClickInner(p.id)}
                            //   className={voteTarget ? "voteTarget" : ""}
                            // >
                            //   <TableCell variant="body">
                            //     {p.player.gameName}
                            //   </TableCell>
                            //   <TableCell variant="body" className="role">
                            //     {showRoles && getRoleString(p.role)}
                            //   </TableCell>
                            //   <TableCell variant="body">
                            //     {currentStatus.filter((el) => el).join(", ")}
                            //   </TableCell>
                            // </TableRow>
                            );
                        }) }), _jsx(TimeImage, { day: day }), addOnComponent === null || addOnComponent === void 0 ? void 0 : addOnComponent({
                        player: selectedPlayer,
                        onClose: onChangeRole,
                        onFouls: onFoulsClick,
                        players: selectedPlayers,
                    })] }) })) }));
};
